import { SimpleMarkdownRenderer } from '@components/Markdown/SimpleMarkdownRenderer';
import { styled } from '@mui/material/styles';

export const HelpMarkdown = styled(SimpleMarkdownRenderer)({ padding: 0 });
